import { makeStyles } from "@material-ui/core";

const useDialogStyles = makeStyles(theme => ({
    dialogTitle: {
        display: "flex",
        alignItems: "center",
        padding: 10,
        borderBottom: "1px solid #ccc",
        paddingBottom: 5,
    },
    dialogContent:{
        padding:0
    },
    title: {
        fontFamily: "OpenSansSemiBold",
        fontSize: "0.85rem"
    },
    button: {
        padding: 5,
        marginLeft: "auto",
        paddingBottom: 2
    }
}));

export default useDialogStyles;